// ============================================================
//  API Utility — All calls to your AWS Lambda / API Gateway
// ============================================================

import { fetchAuthSession } from 'aws-amplify/auth';

const BASE_URL = process.env.REACT_APP_API_URL ||
  "https://XXXXXXXXXX.execute-api.us-east-1.amazonaws.com/prod";

async function apiCall(method, path, body = null) {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();

  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    }
  };
  if (body) options.body = JSON.stringify(body);

  const response = await fetch(`${BASE_URL}${path}`, options);
  if (!response.ok) throw new Error(`API error: ${response.status}`);
  return response.json();
}

// ── Expenses ────────────────────────────────────────────────
export async function addExpense(expense) {
  return apiCall("POST", "/expenses", expense);
}
export async function getExpenses(filters = {}) {
  const params = new URLSearchParams(filters).toString();
  return apiCall("GET", `/expenses${params ? "?" + params : ""}`);
}
export async function deleteExpense(expenseId) {
  return apiCall("DELETE", `/expenses/${expenseId}`);
}

// ── Receipts ─────────────────────────────────────────────────
export async function getUploadUrl(filename, contentType) {
  return apiCall("POST", "/receipts/upload-url", { filename, contentType });
}
export async function uploadReceiptToS3(presignedUrl, file) {
  const response = await fetch(presignedUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file
  });
  if (!response.ok) throw new Error("Upload failed");
  return true;
}
export async function scanReceipt(s3Key) {
  return apiCall("POST", "/receipts/scan", { s3Key });
}

// ── AI Photo Estimate ──────────────────────────────────────
export async function estimateFromPhoto(imageBase64, mediaType, contextNote) {
  return apiCall("POST", "/estimate/photo", { imageBase64, mediaType, contextNote });
}

// ── Reports ──────────────────────────────────────────────────
export async function getSummaryByJob() {
  return apiCall("GET", "/reports/by-job");
}
export async function getSummaryByCategory() {
  return apiCall("GET", "/reports/by-category");
}
